import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=182778a9&"
import script from "./Insurance.vue?vue&type=script&lang=js&"
export * from "./Insurance.vue?vue&type=script&lang=js&"
import style0 from "./Insurance.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports